import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IPassportConfiguration } from '@obvious.tech/constellation'

export const PassportConfiguration = defineEntity('PassportConfiguration', {
  endpoint: 'authentication/api/PassportConfiguration',
  schema: SNoop<IPassportConfiguration>(),
})
